<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('productioncompany', 2) }}</div>
      <div>
        <router-link
          class="btn-blue"
          @click.native="goToRoute('/master/edit-production')"
          to
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="productions"
        >{{ $tc('productioncompany', 2) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div v-for="(item,index) in Production" :key="index" class="col-md-12 py-2">
            <div
              class="row border-bottom"
              v-if="item.fieldname == 'created_at' && GetRoleId && GetRoleId === 1"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
            </div>
            <div
              class="row border-bottom"
              v-else-if="item.fieldname == 'updated_at'  && GetRoleId && GetRoleId === 1"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
            </div>
            <div
              class="row border-bottom"
              v-else-if="item.fieldname == 'created_by' && GetRoleId && GetRoleId === 1"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
            <div
              class="row border-bottom"
              v-else-if="item.fieldname === 'updated_by' && GetRoleId && GetRoleId === 1 "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
            <div
              class="row border-bottom"
              v-else-if="item.fieldname !== 'production_id' && item.fieldname !== 'created_at' && item.fieldname !== 'updated_at' && item.fieldname !== 'created_by' && item.fieldname !== 'updated_by'"
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1)}}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Production from "@/helper/formJSONMaster/Production";

export default {
  data() {
    return {
      tableId: null,
      Production: [
        ...Production.ms_production_companies,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: "123456",
          type: "text",
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: true,
          type: "text",
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: true,
          type: "text",
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: true,
          type: "text",
        },
      ],

      Methods: Production.Methods,
      submitted: false,
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.tableId = id;
      this.getViewList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId,
        },
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getViewList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Production.map((x, index) => {
              if (x.fieldname === "created_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "Production");
              } else if (x.fieldname === "updated_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "Production");
              } else if (x.fieldname === "production_is_active") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getViewUsersDetails(user_id, index, key) {
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ProductionCompany/viewProduction.vue